import { initContract } from '@ts-rest/core'
import { ApplyLabelRequestSchema, ApplyLabelResponseSchema } from '../schemas/labels'
import { defaultErrorResponses } from './errors'

const c = initContract()

/**
 * Label Management Contract - Batch apply existing Gmail labels to emails.
 * Uses token-manager for auto-refresh. Batches 500 messages per Gmail API call.
 * All endpoints require authMiddleware and log to activity_logs.
 */
export const labelsContract = c.router({
  /**
   * Applies a Gmail label to a batch of emails. Label must already exist in user's Gmail account.
   * Gets: labelId (Gmail label ID), emailIds[] (array of email/Gmail message IDs) in body.
   * Returns: ApplyLabelResponseSchema with count of emails labeled and operation_id for activity tracking.
   * Side Effects: Updates Gmail (adds label to emails), creates activity_log entry with operation_id and affected email count.
   * Batching: Chunks emails into 500 message batches per Gmail API call.
   */
  apply: {
    method: 'POST',
    path: '/v1/manage/labels/apply',
    body: ApplyLabelRequestSchema,
    responses: {
      200: ApplyLabelResponseSchema,
      ...defaultErrorResponses,
    },
    metadata: {
      auth: true,
      summary: 'Apply an existing Gmail label to emails',
      description: 'Batch apply existing Gmail label to emails. Logs operation to activity_logs.',
    },
  },
})
